export default __webpack_public_path__ + "static/media/logo.b2c6674b.png";